import { render, staticRenderFns } from "./data-overview.vue?vue&type=template&id=749457ec&scoped=true"
import script from "./data-overview.vue?vue&type=script&lang=js"
export * from "./data-overview.vue?vue&type=script&lang=js"
import style0 from "./data-overview.vue?vue&type=style&index=0&id=749457ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749457ec",
  null
  
)

export default component.exports